import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    userRank: Yup.string().required('Required').nullable(),
  });
